import { Box } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import AddAnother from "../add-another/AddAnother";
import SatelliteImage from "./SatelliteImage";
import { SatelliteImageFormValue } from "../../types";

function SatelliteImageryContainer() {
  return (
    <Box data-testid="satellite-imagery-section-collapsible">
      <SectionCollapsible label="Satellite Imagery">
        <AddAnother<SatelliteImageFormValue>
          name="satellite-imagery"
          addLabel="Add satellite image"
          getCounter={(satelliteImage) => satelliteImage.satelliteImageCounter}
          createValue={(satelliteImageCounter) => ({
            mediaLink: "",
            caption: "",
            source: "",
            satelliteImageCounter,
          })}
          compareValues={(firstImage, secondImage) =>
            firstImage.satelliteImageCounter - secondImage.satelliteImageCounter
          }
          renderItem={({ value, index, remove }) => (
            <Box sx={{ paddingBottom: 4 }}>
              <SatelliteImage value={value} index={index} remove={remove} />
            </Box>
          )}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default SatelliteImageryContainer;
